"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TileStateDTO = void 0;
class TileStateDTO {
    constructor() {
        //
        this.placedOrganism = null;
        // points available to the user if they correctly place an organism on it
        this.pointsAvailable = null;
        //
        this.possibleOrganisms = null;
        //
        this.attemptedOrganisms = null;
    }
}
exports.TileStateDTO = TileStateDTO;
//# sourceMappingURL=TileStateDTO.js.map